const Title = () => {
  return (
    <div>
      <h1 className="text-2xl md:text-[32px] font-bold  text-center md:text-left">
        Collections
      </h1>
    </div>
  );
};

export default Title;
